import { render, staticRenderFns } from "./MenuListView.vue?vue&type=template&id=d864fc4c"
import script from "./MenuListView.vue?vue&type=script&lang=js"
export * from "./MenuListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports